import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The kyber crystal that marks an outfit's rarity (the outfit economy; owner, 2026-10-15): white for Common, emerald
 * for Uncommon, orange for Rare, purple for Legendary. One inline SVG, one path, drawn in `currentColor`, so the
 * stylesheet's four colour tokens (gyro.css `--gyro-kyber-*`, with light-theme variants) colour it wherever it is: the
 * picker tile's corner, the character card, later the library, trades and the market, and the Hub's store through this
 * same package. The four files under assets/kyber/ are the same drawing for anything that takes an SVG file (the
 * admin console, documents); outfitCard.render.test.ts holds them to this path.
 */
export const KYBER_CRYSTAL_PATH = 'M12 1.5 18.5 8 12 22.5 5.5 8 12 1.5Zm0 3.2L8.3 8.4 12 18.6l3.7-10.2L12 4.7Z';
/** The crystal of each rarity: fixed product facts (gyro-svc desktopMascotEconomyRules.ts KYBER_CRYSTALS). */
export const KYBER_CRYSTAL_OF = Object.freeze({
    common: 'white',
    uncommon: 'emerald',
    rare: 'orange',
    legendary: 'purple',
});
/** The words people see for a rarity (never the id). */
export const RARITY_LABEL = Object.freeze({
    common: 'Common',
    uncommon: 'Uncommon',
    rare: 'Rare',
    legendary: 'Legendary',
});
export const MASCOT_RARITIES = Object.freeze(['common', 'uncommon', 'rare', 'legendary']);
export function isMascotRarity(value) {
    return typeof value === 'string' && MASCOT_RARITIES.includes(value);
}
/** "Rare kyber crystal": what a screen reader says for the crystal. */
export function kyberCrystalLabel(rarity) {
    return `${RARITY_LABEL[rarity]} kyber crystal`;
}
/** The crystal as an inline SVG, coloured by its rarity's token; `role="img"` with the rarity as its name. */
export function KyberCrystal({ rarity, size = 14, title, className }) {
    const crystal = KYBER_CRYSTAL_OF[rarity];
    return _jsx("span", { className: `gyro-kyber gyro-kyber-${crystal}${className ? ` ${className}` : ''}`, role: "img", "aria-label": kyberCrystalLabel(rarity), title: title ?? kyberCrystalLabel(rarity), "data-rarity": rarity, children: _jsx("svg", { viewBox: "0 0 24 24", width: size, height: size, fill: "currentColor", "aria-hidden": "true", focusable: "false", children: _jsx("path", { d: KYBER_CRYSTAL_PATH }) }) });
}
//# sourceMappingURL=kyberCrystal.js.map